
export class StringUtil {

	public static empty = '';

	public static nullOrEmpty(s: string | null | undefined): boolean {
		return s == null || s.length === 0;
	}
}
